module.exports = __webpack_public_path__ + "img/lc.d40a4b85.jpg";